import styled from "styled-components";

const KidsHeroWrap = styled.div`
  background-color: #ffffff;
  padding: 32px;
  text-align: center;
  h4 {
    margin-top: 0px;
    font-size: 45px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 0px;
  }
`
export default KidsHeroWrap